/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Limited_Purchase_Reached1Inputs */

const en_limited_purchase_reached1 = /** @type {(inputs: Limited_Purchase_Reached1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Purchase limit reached`)
};

const ar_limited_purchase_reached1 = /** @type {(inputs: Limited_Purchase_Reached1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تم الوصول إلى حد الشراء`)
};

const de_limited_purchase_reached1 = /** @type {(inputs: Limited_Purchase_Reached1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kauflimit erreicht`)
};

const es_limited_purchase_reached1 = /** @type {(inputs: Limited_Purchase_Reached1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Límite de compra alcanzado`)
};

const fr_limited_purchase_reached1 = /** @type {(inputs: Limited_Purchase_Reached1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Limite d'achat atteinte`)
};

const it_limited_purchase_reached1 = /** @type {(inputs: Limited_Purchase_Reached1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Limite di acquisto raggiunto`)
};

const ja_limited_purchase_reached1 = /** @type {(inputs: Limited_Purchase_Reached1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`購入上限に達しました`)
};

const ko_limited_purchase_reached1 = /** @type {(inputs: Limited_Purchase_Reached1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`구매 한도에 도달했습니다`)
};

const pt_br_limited_purchase_reached1 = /** @type {(inputs: Limited_Purchase_Reached1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Limite de compra atingido`)
};

const ru_limited_purchase_reached1 = /** @type {(inputs: Limited_Purchase_Reached1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Лимит покупок достигнут`)
};

const th_limited_purchase_reached1 = /** @type {(inputs: Limited_Purchase_Reached1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ถึงขีดจำกัดการซื้อแล้ว`)
};

const tr_limited_purchase_reached1 = /** @type {(inputs: Limited_Purchase_Reached1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Satın alma sınırına ulaşıldı`)
};

const zh_cn_limited_purchase_reached1 = /** @type {(inputs: Limited_Purchase_Reached1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`已达购买上限`)
};

const zh_tw_limited_purchase_reached1 = /** @type {(inputs: Limited_Purchase_Reached1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`已達購買上限`)
};

/**
* | output |
* | --- |
* | "Purchase limit reached" |
*
* @param {Limited_Purchase_Reached1Inputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
const limited_purchase_reached1 = /** @type {((inputs?: Limited_Purchase_Reached1Inputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Limited_Purchase_Reached1Inputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_limited_purchase_reached1(inputs)
	if (locale === "ar") return ar_limited_purchase_reached1(inputs)
	if (locale === "de") return de_limited_purchase_reached1(inputs)
	if (locale === "es") return es_limited_purchase_reached1(inputs)
	if (locale === "fr") return fr_limited_purchase_reached1(inputs)
	if (locale === "it") return it_limited_purchase_reached1(inputs)
	if (locale === "ja") return ja_limited_purchase_reached1(inputs)
	if (locale === "ko") return ko_limited_purchase_reached1(inputs)
	if (locale === "pt_br") return pt_br_limited_purchase_reached1(inputs)
	if (locale === "ru") return ru_limited_purchase_reached1(inputs)
	if (locale === "th") return th_limited_purchase_reached1(inputs)
	if (locale === "tr") return tr_limited_purchase_reached1(inputs)
	if (locale === "zh_cn") return zh_cn_limited_purchase_reached1(inputs)
	return zh_tw_limited_purchase_reached1(inputs)
});
export { limited_purchase_reached1 as "Limited_purchase_reached" }